import { Injectable } from '@angular/core';
import { SystemPropertiesService } from '@app/core/services/system-properties.service';
import { IConfig } from "@common/models/IConfig";
import { firstValueFrom, from, Observable } from 'rxjs';
import { SystemPropertyKey } from '@common/enums/SystemPropertyKey';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private configs: IConfig[] | null = null;
  private cacheLoaded = false;
  constructor(private readonly systemPropertyService: SystemPropertiesService) { }

  public getAllConfigs(): Observable<IConfig[]> {
    return from(this.loadConfigsAndGetAll());
  } 
  public getConfigByMetric(metric: string): Observable<IConfig | null> {
    return from(this.loadConfigsAndGetByMetric(metric));
  }
  private async loadConfigsAndGetAll(): Promise<IConfig[]> {
    if (!this.cacheLoaded) {
      const configValue = await firstValueFrom(
        this.systemPropertyService.getByKey<any>(SystemPropertyKey.configs)
      );
      this.configs = Array.isArray(configValue) ? configValue as IConfig[] : [];
      this.cacheLoaded = true;
    }
    return this.configs || [];
  }
  private async loadConfigsAndGetByMetric(metric: string): Promise<IConfig | null> {
    const configs = await this.loadConfigsAndGetAll();
    return configs.find(c => c.config_name === metric) ?? null;
  }
 
}
